import { render } from "./index.vue?vue&type=template&id=50e8ef04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=50e8ef04&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=50e8ef04&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e8ef04"]])

export default __exports__